import moment from "moment";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Modal from "../modal-new";
import { DATE_FORMATS } from "../../constants";
import Dropdown from "../dropdown";

const { DATE_DAY_FORMAT, DATE_PICKER_FORMAT_FULL_MONTH } = DATE_FORMATS;

const CalendarShiftWorkout = (props, { locals: { query } }) => {
  const [weeks, setWeeks] = useState(1);

  const actualDate = moment
    .utc(query.day, DATE_DAY_FORMAT)
    .format(DATE_PICKER_FORMAT_FULL_MONTH);
  const nextDate = moment
    .utc(query.day, DATE_DAY_FORMAT)
    .add("weeks", weeks)
    .format(DATE_PICKER_FORMAT_FULL_MONTH);

  return (
    <form
      action={`/actions/exercise/shift-day?proxyAthlete=${query.athlete}`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="weeks" value={weeks} />
      <input type="hidden" name="from" value={query.day} />

      <Modal
        className="Shift-Workout export-workout"
        title="Shift Workout"
        toClear={["day"]}
      >
        <div className="body">
          <p className="p2">
            How many weeks do you want to shift the program forward beginning
            with the workout on{" "}
            <span className="font-bold text-[--text-primary]">
              {actualDate}
            </span>
          </p>

          <label className="mt-8">Weeks</label>
          <Dropdown
            options={[1, 2, 3, 4, 5, 6, 7, 8].map((week) => ({
              text: week,
              value: week,
            }))}
            summaryText={weeks}
            onSelectFn={(newVal) => setWeeks(newVal)}
          />
          {/* <select onChange={(evt) => setWeeks(evt.target.value)}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((week, idx) => (
              <option key={idx}>{week}</option>
            ))}
          </select> */}

          <div className="flex items-center justify-between mt-5">
            <p className="p2">Your program will resume on</p>
            <p className="clipped font-bold">{nextDate}</p>
          </div>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="text-white"
            data-action="cancel"
            href="/actions/refresh?modal[type]=&day="
          >
            Cancel
          </a>
          <button role="button" data-button-type="primary" type="submit">
            Shift
          </button>
        </footer>
      </Modal>
    </form>
  );
};

CalendarShiftWorkout.contextTypes = { locals: PropTypes.object };

export default CalendarShiftWorkout;
